import { useContent } from "contexts/contentContext/contentContext.js";
import React, { useState } from "react";
import parse from "html-react-parser";
import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
import Button from "components/Elements/Button/Button.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

const EditSenderDetailsModal = ({
  displayName,
  setDisplayName,
  displayEmailSubject,
  setDisplayEmailSubject,
}) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { addToast } = useToasts();
  const [tempDisplayName, setTempDisplayName] = useState(displayName);
  const [tempDisplayEmailSubject, setTempDisplayEmailSubject] =
    useState(displayEmailSubject);

  const saveSettings = async () => {
    const body = {
      DisplayNameOnGallery: tempDisplayName,
      DisplayEmailSubjectOnGallery: tempDisplayEmailSubject,
    };
    const response = await apiRequest(
      "UserTemplates",
      "UpdateSenderDetailsForGalleryPage",
      body,
      "POST"
    );
    if (response.status === "success") {
      setDisplayName(tempDisplayName);
      setDisplayEmailSubject(tempDisplayEmailSubject);
      addToast(getTextByKey("update-sender-details-success"), {
        appearance: "success",
      });
      closeModal();
    }
  };

  const updateDisplayName = () => {
    setTempDisplayName(!tempDisplayName);
  };

  const updateDisplayEmailSubject = () => {
    setTempDisplayEmailSubject(!tempDisplayEmailSubject);
  };

  return (
    <div className="edit-sender-details-modal">
      <div className="edit-sender-details-modal-container">
        <div className="title-modal">
          <h2>{getTextByKey("display-settings-on-gallery-title")}</h2>
        </div>
        <div className="text-modal">
          {parse(getTextByKey("display-settings-on-gallery-text"))}
        </div>
        <div className="checkboxes">
          <CheckboxElement
            state={tempDisplayName}
            setState={() => updateDisplayName()}
            checkboxLabel={getTextByKey("display-name-on-gallery")}
          />
          <CheckboxElement
            state={tempDisplayEmailSubject}
            setState={() => updateDisplayEmailSubject()}
            checkboxLabel={getTextByKey("display-email-subject-on-gallery")}
          />
        </div>
        <div className="actions">
          <Button className="new-button" onClick={() => saveSettings()}>
            {getTextByKey("save-settings")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditSenderDetailsModal;
